import { useState } from 'react';
import { API_URL, API_VERSION } from '@constants';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';
import { getSessionId } from '@utils/session';

const ENDPOINT_URL = '/auth/forgot-password';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type ResetPasswordInput = paths[url]['post']['requestBody']['content']['application/json'];

/**
 * Requests endpoint to authenticate user.
 */
export const useRequestResetPassword = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();

    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [lastResponseTime, setLastResponseTime] = useState<Date | null>(null);

    const sessionId = getSessionId();

    const request = async (props: ResetPasswordInput) => {
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify({ ...props, session_id: sessionId }),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.message || '') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            handleCommonErrors(err);
            err.message && setError(err.message);
        } finally {
            setLoading(false);
            setLastResponseTime(new Date());
        }
    };

    return { request, loading, error, lastResponseTime };
};
